export const DUTCH_SOLUTION_CONTENT = {
  1: {
    slug: 'narrowcasting-voor-zorg',
    translation: {
      title: 'Narrowcasting voor zorg en wachtkamers',
      description: 'Toon wachttijden, gezondheidsinformatie en aankondigingen op elk scherm. Beheer narrowcasting voor zorglocaties eenvoudig op afstand.',
      date: '3 oktober 2025',
      datePublished: '2025-10-03',
      dateModified: '2026-09-19',
      content: `
        <h2>Wat is narrowcasting in de zorg?</h2>
        <p>Narrowcasting zorg gebruikt digitale schermen om bezoekers, patiënten en medewerkers op het juiste moment van duidelijke algemene informatie te voorzien. Met AdCast kunnen ziekenhuizen, klinieken, praktijken en zorginstellingen schermen centraal beheren, zonder langs elk scherm te hoeven gaan.</p>
        <h2>Narrowcasting voor wachtkamers</h2>
        <p>Een wachtkamer informatiescherm kan geschatte wachttijden, openingstijden, route-informatie, bezoekregels en praktische aankondigingen tonen. Informatie op schermen in de wachtkamer helpt bezoekers zich te oriënteren en kan terugkerende vragen aan de balie verminderen.</p>
        <h2>Welke informatie kunt u tonen?</h2>
        <p>Digitale schermen zorg kunnen algemene gezondheidsinformatie, preventietips, nieuws uit de praktijk, veranderingen in openingstijden, veiligheidsinstructies en aankondigingen weergeven. Voor medewerkers zijn afzonderlijke playlists mogelijk voor roosters, trainingen en interne meldingen.</p>
        <p>Gebruik geen gevoelige patiëntgegevens in publieke content. AdCast is bedoeld voor algemene schermcommunicatie en biedt geen toegang tot of weergave van patiëntgegevens, tenzij een specifieke functie daarvoor aantoonbaar wordt ondersteund en rechtmatig is ingericht.</p>
        <h2>Beheer schermen op afstand</h2>
        <p>Werk content bij vanaf een telefoon of laptop en publiceer wijzigingen naar één scherm, een schermgroep of meerdere locaties. Verschillende afdelingen kunnen verschillende playlists krijgen, bijvoorbeeld voor een apotheek, balie, wachtruimte of personeelsruimte.</p>
        <h3>Planning en belangrijke meldingen</h3>
        <p>Met playlists en planning laat u informatie automatisch wisselen per tijdstip, dag of locatie. Een belangrijke of urgente algemene boodschap kan vervolgens direct op de relevante schermen worden geplaatst.</p>
        <h2>Voor welke zorglocaties is AdCast geschikt?</h2>
        <p>AdCast kan worden gebruikt voor schermcommunicatie in klinieken, huisartsenpraktijken, ziekenhuizen, apotheken, tandartspraktijken, fysiotherapiepraktijken en zorginstellingen. Begin met een ondersteund scherm en AdCast Player, koppel via QR-code en breid later uit naar extra ruimtes of vestigingen.</p>
        <h2>Veelgestelde vragen</h2>
        <h3>Kan ik wachttijden in de wachtkamer tonen?</h3><p>Ja, u kunt algemene wachttijdinformatie en aankondigingen als content publiceren en op de relevante schermen plannen.</p>
        <h3>Kunnen meerdere locaties verschillende content tonen?</h3><p>Ja. Maak playlists per locatie, ruimte of schermgroep en publiceer alleen de content die daar relevant is.</p>
        <h3>Kan ik informatie op afstand aanpassen?</h3><p>Ja. Geautoriseerde gebruikers kunnen afbeeldingen, video's en playlists bijwerken zonder USB-sticks langs schermen te brengen.</p>
        <h3>Is AdCast bedoeld voor patiëntgegevens?</h3><p>Nee. Gebruik AdCast voor algemene communicatie en plaats geen gevoelige patiëntgegevens op publieke schermen.</p>
      `
    }
  },
  2: {
    slug: 'narrowcasting-voor-horeca',
    translation: {
      title: 'Narrowcasting & Digitale Menuborden voor Horeca en Restaurants',
      description: 'Maak en beheer digitale menuborden voor restaurants, cafés en horeca met AdCast. Pas prijzen, acties en dagmenu’s op afstand aan via Android TV en Fire TV.',
      date: '3 oktober 2025',
      datePublished: '2025-10-03',
      dateModified: '2026-09-05',
      content: `
        <h2>Narrowcasting voor horeca met AdCast</h2>
        <p>Restaurants, cafés, lunchrooms en koffiezaken kunnen met AdCast hun tv-schermen gebruiken voor professionele narrowcasting. Toon menu's, acties, productfoto's en merkcontent en beheer alles op afstand vanaf je telefoon.</p>

        <h3>Digitale menuborden voor restaurants en cafés</h3>
        <p><strong>Digitale menuborden</strong> maken het eenvoudig om prijzen, dagspecials en tijdelijke aanbiedingen actueel te houden. Wijzig een prijs één keer in je content, publiceer de nieuwe versie en laat die op de juiste schermen verschijnen zonder nieuwe posters te printen.</p>

        <h3>Verschillende menu's per moment van de dag</h3>
        <p>Plan een ontbijtmenu in de ochtend, lunchaanbiedingen rond de middag en avondpromoties later op de dag. Met playlists en planning kun je content automatisch laten wisselen op vooraf gekozen tijden.</p>

        <h3>Promoot producten met een hogere marge</h3>
        <p>Gebruik opvallende afbeeldingen en video's om populaire drankjes, desserts, combideals en seizoensproducten extra aandacht te geven. Wissel commerciële content af met het reguliere menu zonder dat je het volledige ontwerp telkens opnieuw hoeft te maken.</p>

        <h3>Van Canva naar je horecascherm</h3>
        <p>Maak een ontwerp in Canva, exporteer het naar AdCast en gebruik het vervolgens in een advertentie of playlist. Zo combineer je de ontwerpmogelijkheden van Canva met de publicatie- en planningsfuncties van AdCast.</p>

        <img src="/assets/img/solution/coffee_shop2.jpg" alt="Digitale menuborden en narrowcasting voor horeca" style="width:100%; margin:20px 0;" />

        <h3>Geen USB-sticks of handmatige updates</h3>
        <p>Installeer de <strong>AdCast Player</strong> op een ondersteund Android TV- of Fire TV-apparaat, koppel het scherm en beheer daarna je content op afstand. Een wijziging in je menu hoeft niet meer te betekenen dat iemand fysiek naar iedere tv moet lopen.</p>

        <h3>Start met de schermen die je al hebt</h3>
        <p>Veel moderne tv's kunnen prima worden gebruikt als horecascherm. AdCast helpt kleine bedrijven een betaalbare narrowcastingoplossing op te zetten zonder een ingewikkelde infrastructuur of speciaal signage-hardwarepakket.</p>
      `
    }
  },
  3: {
    slug: 'narrowcasting-voor-sportscholen',
    translation: {
      title: 'Narrowcasting & Digital Signage voor Sportscholen en Fitness',
      description: 'Gebruik narrowcasting in je sportschool voor lesroosters, acties, trainers, wellnessinformatie en promoties. Beheer alle fitnessschermen op afstand met AdCast.',
      date: '3 oktober 2025',
      datePublished: '2025-10-03',
      dateModified: '2026-09-05',
      content: `
        <h2>Narrowcasting voor sportscholen met AdCast</h2>
        <p>AdCast helpt sportscholen en fitnesscentra om leden te informeren en motiveren op de plek waar het relevant is: in de club. Gebruik Android TV of een ondersteund Android-apparaat met de <strong>AdCast Player</strong> om bestaande schermen om te zetten in dynamische narrowcastingschermen.</p>

        <h3>Lesroosters en dagelijkse informatie</h3>
        <p>Toon groepslesroosters, wijzigingen, openingstijden, zaalbezetting, evenementen en huisregels. Door content te plannen kun je informatie automatisch laten wisselen per tijdstip of zone.</p>

        <h3>Promoties zonder extra advertentiekanaal</h3>
        <p>Je schermen bereiken leden die al in je club aanwezig zijn. Promoot personal training, premium lidmaatschappen, herstelservices, supplementen, workshops of partneraanbiedingen zonder te concurreren met externe advertenties.</p>

        <h3>Maak trainers en resultaten zichtbaar</h3>
        <p>Introduceer personal trainers, toon succesverhalen van leden en deel korte trainings- of voedingstips. Zo wordt narrowcasting niet alleen een advertentiekanaal, maar ook onderdeel van de ledenervaring.</p>

        <h3>Content per zone</h3>
        <p>Maak afzonderlijke playlists voor cardio, krachttraining, receptie, studio's of de koffiebar. Ieder scherm of iedere schermgroep kan eigen content en een eigen planning krijgen.</p>

        <h3>Beheer vanaf je telefoon</h3>
        <p>Upload afbeeldingen en video's, bouw playlists en werk schermen op afstand bij. Geen USB-sticks en geen bezoek aan ieder scherm wanneer een rooster of actie verandert.</p>

        <h3>Snel starten met bestaande tv's</h3>
        <p>Installeer AdCast Player, koppel het scherm via QR-code en publiceer je eerste playlist. Zo kan een sportschool eenvoudig beginnen met digital signage en later uitbreiden naar meerdere ruimtes of vestigingen.</p>
      `
    }
  },
  4: {
    slug: 'narrowcasting-voor-recepties',
    translation: {
      title: 'Narrowcasting & Digital Signage voor Recepties en Lobby’s',
      description: 'Gebruik narrowcasting bij recepties en in lobby’s voor welkomstberichten, route-informatie, aankondigingen en interne communicatie. Beheer schermen op afstand met AdCast.',
      date: '3 oktober 2025',
      datePublished: '2025-10-03',
      dateModified: '2026-09-05',
      content: `
        <h2>Narrowcasting voor recepties en lobby's</h2>
        <p>Hotels, kantoren, bedrijfsverzamelgebouwen en wooncomplexen kunnen narrowcasting gebruiken om bezoekers welkom te heten, wegwijs te maken en actuele informatie te tonen. Met AdCast beheer je receptieschermen op afstand vanaf je telefoon of laptop.</p>

        <h3>Wat heb je nodig?</h3>
        <p>Gebruik een bestaand scherm met een ondersteund Android TV- of Android-apparaat waarop de <strong>AdCast Player</strong> draait. Koppel het scherm met AdCast en publiceer vervolgens afbeeldingen, video's, aankondigingen en agenda's naar één of meerdere recepties.</p>

        <h3>Een digitaal receptiescherm altijd actueel houden</h3>
        <p>Zonder cloudbeheer moet iemand ieder scherm handmatig bijwerken. AdCast laat teams content uploaden, plannen en publiceren vanaf iedere locatie met internet. Hierdoor blijven openingstijden, bezoekersinformatie en mededelingen actueel.</p>

        <h3>Content voor bezoekers</h3>
        <p>Toon welkomstberichten, bedrijfs- of afdelingsgidsen, routekaarten, openingstijden, evenementen, wachtrij-informatie en serviceberichten. Voor speciale bezoeken kun je tijdelijk een persoonlijke begroeting of bedrijfslogo tonen.</p>

        <h3>Content voor medewerkers</h3>
        <p>Gebruik interne schermen voor aankondigingen, vergaderingen, beschikbare ruimtes, KPI's, verjaardagen, veiligheidsinformatie of interne campagnes.</p>

        <h3>Plan content vooruit</h3>
        <p>Maak een eenvoudige kalender met evenementen, veiligheidsmeldingen, dashboards en merkcontent. Plan items voor specifieke data en tijden zodat het receptiescherm automatisch relevant blijft.</p>

        <h3>Van één lobby naar meerdere locaties</h3>
        <p>Begin met één scherm en voeg later schermgroepen of extra vestigingen toe. Updates blijven centraal beheerd, zodat je niet afhankelijk bent van USB-sticks, kabels of handmatige rondes langs ieder scherm.</p>
      `
    }
  },
  5: {
    slug: 'narrowcasting-voor-salons',
    translation: {
      title: 'Narrowcasting voor Kapsalons, Barbershops en Beautysalons',
      description: 'Gebruik narrowcasting in kapsalons en beautysalons om diensten, prijzen, portfolio’s, reviews en acties te tonen. Werk je scherm in seconden bij met AdCast.',
      date: '11 april 2026',
      datePublished: '2026-04-11',
      dateModified: '2026-09-05',
      content: `
        <h2>Narrowcasting voor salons met AdCast</h2>
        <p>Kapsalons, barbershops en beautystudio's kunnen met AdCast professionele schermcommunicatie opzetten zonder ingewikkelde hardware. Gebruik een scherm, een ondersteund Android TV-apparaat en de <strong>AdCast Player</strong>, koppel het scherm en beheer daarna de content vanaf je telefoon.</p>

        <h3>Toon diensten en actuele prijzen</h3>
        <p>Een scherm in de wachtruimte of bij de receptie is ideaal voor je volledige aanbod. Toon knippen, kleuren, föhnen, nagelbehandelingen, huidverzorging of andere services met actuele prijzen. Klanten die wachten ontdekken zo makkelijker aanvullende behandelingen.</p>

        <h3>Laat je portfolio zien</h3>
        <p>Voor-en-na-foto's laten direct zien wat je team kan. Maak een visuele rotatie van kapsels, kleurwerk, baardstyling, nagels of beautybehandelingen en laat nieuwe klanten kennismaken met je werk.</p>

        <img src="/assets/img/solution/digital_signage_in_barber_shop.jpeg" alt="Narrowcasting voor kapsalons en barbershops" style="width:100%; margin:20px 0;" />

        <h3>Promoot acties en arrangementen</h3>
        <p>Een seizoensactie, last-minute aanbod of speciaal arrangement kan in enkele seconden worden bijgewerkt. Plan een promotie vooraf en laat deze automatisch verdwijnen wanneer de actieperiode voorbij is.</p>

        <h3>Stel je team voor</h3>
        <p>Toon de naam, foto en specialiteiten van iedere stylist of behandelaar. Dat helpt nieuwe klanten de juiste medewerker te kiezen en maakt expertise zichtbaar.</p>

        <h3>Reviews en social proof op het scherm</h3>
        <p>Gebruik sterke klantbeoordelingen samen met foto's van resultaten en een korte call-to-action. Zo wordt wachttijd een kans om vertrouwen op te bouwen en herhaalboekingen of aanvullende diensten te stimuleren.</p>

        <h3>Verkoop producten beter</h3>
        <p>Highlight shampoos, conditioners, stylingproducten of huidverzorgingslijnen met aantrekkelijke afbeeldingen en korte uitleg. Een scherm bij de wachtruimte of kassa kan producten extra zichtbaar maken.</p>

        <h3>Start in enkele minuten</h3>
        <p>Installeer de AdCast Player, verbind je scherm en publiceer je eerste playlist. Daarna beheer je narrowcasting voor je salon op afstand - zonder USB-sticks en zonder telkens een laptop bij het scherm nodig te hebben.</p>
      `
    }
  }
};

export function withDutchSolution(solution) {
  const nl = DUTCH_SOLUTION_CONTENT[solution.id];
  if (!nl) return solution;
  const slug = typeof solution.slug === 'string'
    ? { en: solution.slug, nl: nl.slug }
    : { ...solution.slug, nl: nl.slug };
  return {
    ...solution,
    slug,
    translations: { ...solution.translations, nl: nl.translation },
  };
}
